import { Observable, of } from 'rxjs';
import { map, tap, switchMap } from 'rxjs/operators';

export function paginationConsumer<T>(
  partial: (pageNumber: number) => Observable<{ rows: T[]; hasMore: boolean }>,
  initialPage = 1
): Observable<T[]> {
  const rows: T[] = [];
  const run = (pageNumber: number): Observable<T[]> => {
    return partial(pageNumber).pipe(
      tap((incoming) => rows.push(...incoming.rows)),
      switchMap((incoming) => (incoming.hasMore ? run(pageNumber + 1) : of(rows)))
    );
  };
  return run(initialPage);
}

export function sgPaginationConsumer<T>(
  partial: (pageNumber: number) => Observable<{ rows?: T[]; paging?: { totalPages?: number } }>,
  initialPage = 1
): Observable<T[]> {
  return paginationConsumer<T>((pageNumber) => {
    return partial(pageNumber).pipe(
      map((result) => ({ hasMore: pageNumber < result.paging.totalPages, rows: result.rows }))
    );
  }, initialPage);
}

export function tokenBasedPaginationConsumer<T>(
  partial: (nextPageToken: string) => Observable<{ data: T[]; token: string }>,
  initialToken: any = null
): Observable<T[]> {
  const rows: T[] = [];
  const run = (nextPageToken: string): Observable<T[]> => {
    return partial(nextPageToken).pipe(
      tap((incoming) => rows.push(...incoming.data)),
      switchMap((incoming) => (incoming.token ? run(incoming.token) : of(rows)))
    );
  };
  return run(initialToken);
}

export function sgTokenBasedPaginationConsumer<T>(
  partial: (nextPageToken: string) => Observable<{ data?: T[]; nextPageToken?: string }>,
  initialToken: string = null
): Observable<T[]> {
  return tokenBasedPaginationConsumer<T>((nextPageToken) => {
    return partial(nextPageToken).pipe(map((result) => ({ token: result.nextPageToken, data: result.data })));
  }, initialToken);
}
